var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.00008C21.75 8.41008 21.41 8.75008 21 8.75008H3C2.59 8.75008 2.25 8.41008 2.25 8.00008C2.25 7.59008 2.59 7.25008 3 7.25008H4.02L4.4 5.44008C4.76 3.69008 5.51 2.08008 8.49 2.08008H15.51C18.49 2.08008 19.24 3.69008 19.6 5.44008L19.98 7.25008H21C21.41 7.25008 21.75 7.59008 21.75 8.00008Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1801 13.66C22.0301 12.01 21.5901 10.25 18.3801 10.25H5.62009C2.41009 10.25 1.98009 12.01 1.82009 13.66L1.26009 19.75C1.19009 20.51 1.44009 21.27 1.96009 21.84C2.49009 22.42 3.24009 22.75 4.04009 22.75H5.92009C7.54009 22.75 7.85009 21.82 8.05009 21.21L8.25009 20.61C8.48009 19.92 8.54009 19.75 9.44009 19.75H14.5601C15.4601 19.75 15.4901 19.85 15.7501 20.61L15.9501 21.21C16.1501 21.82 16.4601 22.75 18.0801 22.75H19.9601C20.7501 22.75 21.5101 22.42 22.0401 21.84C22.5601 21.27 22.8101 20.51 22.7401 19.75L22.1801 13.66ZM9.00009 15.75H6.00009C5.59009 15.75 5.25009 15.41 5.25009 15C5.25009 14.59 5.59009 14.25 6.00009 14.25H9.00009C9.41009 14.25 9.75009 14.59 9.75009 15C9.75009 15.41 9.41009 15.75 9.00009 15.75ZM18.0001 15.75H15.0001C14.5901 15.75 14.2501 15.41 14.2501 15C14.2501 14.59 14.5901 14.25 15.0001 14.25H18.0001C18.4101 14.25 18.7501 14.59 18.7501 15C18.7501 15.41 18.4101 15.75 18.0001 15.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarv2);
export default __webpack_public_path__ + "static/media/carv2.7daa8e94cc6e9e5e7b13ccac7bff2f65.svg";
export { ForwardRef as ReactComponent };